// Store listings for the Ginastee app, and the smart link the QR code encodes.

export const APP_STORE_URL = 'https://apps.apple.com/br/app/ginastee/id6448853593';
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.ginastee';

// Public route that sends a phone to its own store (see pages/DownloadApp).
// One link serves both platforms, so the QR code never has to guess the device.
export const DOWNLOAD_PATH = '/download';

const STORE_URLS = {
    ios: APP_STORE_URL,
    android: PLAY_STORE_URL,
};

export function storeUrlFor(os) {
    return STORE_URLS[os] || null;
}

export function downloadLinkUrl() {
    return `${window.location.origin}${DOWNLOAD_PATH}`;
}

export function downloadLinkDisplay() {
    return `${window.location.host}${DOWNLOAD_PATH}`;
}
